import Vue from "vue";

export const TopBarLoaderEventBus = new Vue();
